import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { GridCloseIcon } from "@mui/x-data-grid";
import Progress from "./Progress";

const ViewStatusTimeline = ({ onClose, isOpen, input,fetchAgreement }) => {

  const [timeline, setTimeline] = useState([]);

  useEffect(() => {
    if (Array.isArray(input?.timeline)) {
      setTimeline(input.timeline);
    } else {
      setTimeline([]);
    }
  }, [input?.timeline]);

  const currentStepIndex = Array.isArray(timeline)
    ? timeline.findIndex((s) => !s.done)
    : -1;

  const step =
    currentStepIndex === -1
      ? timeline.length
      : currentStepIndex;

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <div className="result-drawer">

        <div className="job-results">
          <p className="view-result">Agreement Status</p>
          <div className="close-button">
            <GridCloseIcon onClick={onClose} />
          </div>
        </div>

        <hr style={{ marginTop: 0 }} />

        {/* LOADING */}
        {!input && (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-500">Loading timeline...</p>
          </div>
        )}

        {/* TIMELINE */}
        {input && timeline.length > 0 && (
          <>
            <div
              style={{
                position: "relative",
                paddingLeft: "20px",
                marginTop: "20px",
              }}
            >
              <Progress
                totalSteps={timeline.length}
                step={step}
                vertical={true}
              />

              {timeline.map((stepItem, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    marginBottom: "1.5rem",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      marginRight: "1rem",
                      position: "relative",
                      zIndex: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "9999px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: stepItem.done
                          ? "#0061bb"
                          : "#d1d5db",
                      }}
                    >
                      {stepItem.done ? (
                        <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
                          ✓
                        </span>
                      ) : (
                        <span style={{ color: "#6b7280", fontSize: "14px" }}>
                          •
                        </span>
                      )}
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: stepItem.done ? "#0061bb" : "#6b7280",
                        fontWeight: "500",
                      }}
                    >
                      {stepItem.title}
                    </p>

                    <p
                      style={{
                        fontSize: "0.875rem",
                        color: stepItem.done ? "#374151" : "#9ca3af",
                        marginTop: "2px",
                      }}
                    >
                      {stepItem.timestampText}
                    </p>
                  </div>
                </div>
              ))}

            </div>

            {input?.canView && (
              <button
                className="learnmore-btn"
                onClick={() => {
                  onClose();
                  fetchAgreement?.(input?.envelopeId, "envelope");
                }}
              >
                View Agreement
              </button>
            )}
          </>
        )}

        {/* AUTORESPONDED CASE */}
        {input && timeline.length === 0 && input?.autoresponded && (
          <div
            style={{
              padding: "20px",
              marginTop: "20px",
            }}
          >
            <p>{input.autorespondedText}</p>
          </div>
        )}

      </div>
    </Drawer>
  );
};

export default ViewStatusTimeline;